import * as actions from './actionTypes';
import { INotification } from './reducers';


export const getUserNotifications = () => ({
	type: actions.GET_USER_NOTIFICATIONS
})

export const getUserNotificationsSuccess = (notifications: INotification[]) => ({
	type: actions.GET_USER_NOTIFICATIONS_SUCCESS,
	payload: notifications
})

export const updateSeenStatus = (seen: boolean) => ({
	type: actions.UPDATE_SEEN_STATUS,
	payload: seen
})

export const resetUserNotifications = () => ({
	type: actions.RESET_USER_NOTIFICATIONS
})